import { authAxios} from "../config";
import { ApiKey } from "../endpoints";

export const GetSubscribers = async (reqData) => {
  try {
    const res = await authAxios.post(`${ApiKey.GetRegisteredEmail}`, reqData);
    return res.data;
   
  } 
  catch (err) {
    let error = err.response.data;
    return error;
  }
};